import { render, staticRenderFns } from "./ActivityPageSettings.vue?vue&type=template&id=0b3acf0e&scoped=true"
import script from "./ActivityPageSettings.vue?vue&type=script&lang=js"
export * from "./ActivityPageSettings.vue?vue&type=script&lang=js"
import style0 from "./ActivityPageSettings.vue?vue&type=style&index=0&id=0b3acf0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3acf0e",
  null
  
)

export default component.exports